import axios from "./axiosClient";

/**
 * Get auto-assign config for an account
 */
export const getConfig = (accountId) => {
  return axios.get(`/auto-assign/config/${accountId}`);
};

/**
 * Save auto-assign config
 */
export const saveConfig = (config) => {
  return axios.post("/auto-assign/config", config);
};

export default {
  getConfig,
  saveConfig,
};
